<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        گزارشات پرسنل
        <template v-slot:action>
          <q-btn icon="close" flat v-close-popup round/>
          <q-btn icon="print" flat @click="loadPrintCommentsReports" round
                 v-if="itemsOptions && itemsOptions.length>0"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding text-center">
      <q-chip square color="indigo" text-color="white"
              :label="`پیگیری های صورت گرفته از تاریخ ${startDate} تا تاریخ ${endDate}`">
        <q-badge color="red" text-color="white" class="q-ml-xs"
                 :label="lodash.sumBy(summaryItems, item=>item.EntryCount)"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding text-center">
      <q-chip square clickable v-for="(item, index) in summaryItems" :key="`summaryItem${index}`" color="indigo"
              text-color="white" @click="showDetails(item)">
        {{ item.UserName }}
        <q-badge color="red" text-color="white" floating :label="item.EntryCount"/>
      </q-chip>
    </q-card-section>
    <q-card-section class="no-padding">
      <div class="row q-gutter-xs" v-if="items && items.length>0">
        <div class="col-xs-12 col-md-3">
          <q-expansion-item
              class="shadow-1 overflow-hidden"
              icon="person"
              :default-opened="!$q.screen.lt.md"
              label="توضیحات ثبت شده"
              header-class="bg-primary text-white"
              expand-icon-class="text-white">
            <div class="row">
              <div class="col-xs-12 col-md-12">
                <q-select
                    :dense="$q.screen.lt.md"
                    class="q-ml-md"
                    v-model="logType"
                    filled
                    :options="$store.state.visitLogTypeList.map(item=> item.title)"
                    label="فیلتر اطلاعات بر اساس نوع گزارش"
                />
              </div>
            </div>
            <div class="row" v-if="days && days.length>0">
              <div class="col-xs-12 col-md-12 justify-center text-center">
                <q-chip label="همه" square clickable @click="clearFilterDay"/>
                <q-chip v-for="item in days" :key="item" :label="item" square clickable @click="filterDays(item)"/>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-md-12">
                <q-scroll-area :style="!$q.screen.lt.md?'height: 700px;':'height: 400px;'">
                  <apexchart type="pie" :options="CustomerCommentChartOptions.chartOptions"
                             :series="CustomerCommentChartOptions.chartOptions.series"></apexchart>
                  <q-space/>
                  <q-timeline color="secondary" class="q-pa-md">
                    <q-timeline-entry v-for="row in itemsOptions"
                                      :key="row.ID"
                                      color="indigo"
                                      :subtitle='row.PersianVisitDateTime'
                                      icon="person">
                      <div class="text-subtitle2">
                        <q-chip clickable @click="showCustomerInfoDialog(row.Cs_ID)" v-if="row.Cs_Name" square
                                size="sm" :label="row.Cs_Name" icon="person"/>
                        <q-chip square
                                size="sm" :label="row.VisiType" icon="group_work"/>
                        <q-chip square v-if="$store.state.userName!== row.UserName"
                                size="sm" :label="row.UserName" icon="support_agent"/>
                        <q-chip square :size="$q.screen.lt.md?'sm':'md'" v-if="row.IsSecret" color="red"
                                text-color="white"
                                label="محرمانه" icon="visibility"/>
                      </div>
                      <div v-if="row.GroupsInfo && row.GroupsInfo!=='NULL'">
                        <q-chip size="sm" square v-for="(item, index) in JSON.parse(row.GroupsInfo)"
                                icon="tag"
                                :key="index" :label="item.Group_Name"/>
                      </div>
                      <div>
                        {{ row.VisitComment }}
                      </div>
                      <div class="text-subtitle2">
                        <q-btn icon="add_task" round flat padding="none" color="green-10" @click="showTaskDialog(row)"
                               v-if="$store.state.roles.some(v=>['admin','can_define_task_from_comment'].includes(v))"/>
                        <q-btn icon="edit" round flat padding="none" color="green-10"
                               v-if="
                             Math.floor((new Date() - new Date(row.VisitDateTime)) / 60000)<=60 &&
                             $store.state.roles.some(v=>['admin','can_chane_visit_log_comment'].includes(v))">
                          <q-popup-edit
                              :content-style="$q.screen.lt.md?'':'width:600px'"
                              persistent
                              anchor="center middle"
                              v-model="row.VisitComment"
                              @save="(value, initializeValue)=>editComment(value, initializeValue, row)"
                              auto-save
                              v-slot="scope">
                            <q-input v-model="scope.value" dense autofocus counter @keyup.enter="scope.set">
                              <template v-slot:after>
                                <q-btn
                                    round
                                    flat dense color="negative" icon="cancel"
                                    @click.stop.prevent="scope.cancel"
                                />

                                <q-btn
                                    round
                                    flat dense color="positive" icon="check_circle"
                                    @click.stop.prevent="scope.set"
                                    :disable="scope.validate(scope.value) === false || scope.initialValue === scope.value"
                                />
                              </template>
                            </q-input>

                          </q-popup-edit>
                        </q-btn>
                      </div>
                    </q-timeline-entry>
                  </q-timeline>
                </q-scroll-area>
              </div>
            </div>
          </q-expansion-item>
        </div>
        <div class="col-xs-12 col-md-3">
          <q-expansion-item
              class="shadow-1 overflow-hidden"
              icon="attach_money"
              :default-opened="!$q.screen.lt.md"
              label="پاداش"
              header-class="bg-primary text-white"
              expand-icon-class="text-white">
            <Rewards :user-id="selectedUsersId" :end-date="endDate" :start-date="startDate"/>
          </q-expansion-item>
        </div>

        <div class="col-xs-12 col-md-5 items-center justify-center">
          <q-expansion-item
              :default-opened="!$q.screen.lt.md"
              class="shadow-1 overflow-hidden"
              icon="person"
              label="لیست مشتریان ثبت شده"
              header-class="bg-primary text-white"
              expand-icon-class="text-white"
          >
            <CustomersList :compact-view="true" :is-dialog="false" :items="customerAdded" :buy-list="false"
                           :is-only-search-list="true"/>
          </q-expansion-item>
        </div>
      </div>
    </q-card-section>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <customer-info :selectedCustomer.sync="selectedCustomer"/>
    </q-dialog>

    <q-dialog v-model="taskDialog" :maximized="$q.screen.lt.md">
      <CreateTask :comment-info="selectedComment" @close-dialog="closeTaskDialog"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import CreateTask from "../Task/CreateTask";
import CustomersList from "@/components/customers/CustomersList.vue";
import Rewards from "@/components/Agents/Rewards/Rewards.vue";

export default {
  name: "UserComments",
  components: {Rewards, CustomersList, CreateTask, CustomerInfo},
  props: {
    customerInfo: {
      type: Object
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },
  data() {
    return {
      reportItems: [
        {label: 'نمایش غیر محرمانه ها', value: 0},
        {label: 'نمایش فقط محرمانه ها', value: 1},
        {label: 'همه', value: -99}
      ],
      reportItemsOptions: undefined,
      selectedUsersId: undefined,
      rewards: [],
      selectedComment: undefined,
      taskDialog: false,
      logType: undefined,
      postObject: {
        pageNumber: 1,
        rowsOfPage: 5,
        conditions: {
          startDate: this.startDate,
          endDate: this.endDate,
          userId: this.$store.state.userId,
          isSecure: -99
        },
      },
      userRequest: {
        pageNumber: 1,
        rowsOfPage: 5,
        conditions: {
          startDate: this.startDate,
          endDate: this.endDate,
          userId: this.$store.state.userId,
          isSecure: -99
        },
      },
      showCustomerFullInfo: false,
      selectedCustomer: '',
      items: [],
      customerAdded: [],
      days: [],
      itemsOptions: [],
      summaryItems: [],
      summaryCustomerItems: [],
      userSummaryItems: [],
      summaryCustomers: [],
      wordCloudItems: [],
      CustomerCommentChartOptions: {
        chartOptions: {
          chart: {
            fontFamily: 'IRANSans, sans-serif',
          },
          width: 200,
          legend: {
            show: true,
            position: 'top',
            floating: false,
            customLegendItems: []
          },
          series: [],
          labels: [],
        }
      },
    }
  },
  methods: {
    ...mapActions({
      setItems: 'Customers/getComments',
      getCustomerInfo: 'Customers/get_customer_info',
      getUserReports: 'Dashboard/getUserReports',
      getUserCommentsPaging: 'Customers/getUserCommentsPaging',
      updateCustomerVisitComment: 'Customers/updateCustomerVisitComment',
    }),
    loadPrintCommentsReports() {
      this.$q.dialog({
        title: 'نوع گزارش',
        message: 'نوع وضعیت نمایش اطلاعات را مشخص نمایید:',
        options: {
          type: 'radio',
          model: -99,
          items: this.reportItemsOptions
        },
        cancel: true,
        persistent: true
      }).onOk(async (data) => {
        console.log(JSON.stringify(this.postObject))
        await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات بازاریابان/گزارشات ثبت شده یک کارشناس?StartDate=${this.startDate.replaceAll('/', '-')}&EndDate=${this.endDate.replaceAll('/', '-')}&UserID=${this.selectedUsersId}&IsSecret=${data}&rs:Format=PDF&rc:Parameters=False&rc:Zoom=Page Width`)
      }).onCancel(() => {
        // console.log('>>>> Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    },
    editComment(value, initializeValue, item) {
      this.updateCustomerVisitComment({
        Id: item.ID,
        newComment: value
      }).catch(() => {
        item.VisitComment = initializeValue
      })
    },
    filterDays(item) {
      this.itemsOptions = this.items.filter(rec => rec.PersianVisitDateTimeDay === item)
      const userSummaryData = this.lodash(this.itemsOptions).groupBy('LogType')
          .map(function (items, LogType) {
            return {
              LogType: LogType,
              LogTypeCount: items.length,
            };
          }).value();
      this.CustomerCommentChartOptions.chartOptions = {
        series: userSummaryData.map(item => item.LogTypeCount),
        labels: userSummaryData.map(item => item.LogType),
        legend: {
          customLegendItems: userSummaryData.map(item => `${item.LogType} (${item.LogTypeCount})`)
        }
      }
    },
    clearFilterDay() {
      this.itemsOptions = this.items
      const userSummaryData = this.lodash(this.itemsOptions).groupBy('LogType')
          .map(function (items, LogType) {
            return {
              LogType: LogType,
              LogTypeCount: items.length,
            };
          }).value();
      this.CustomerCommentChartOptions.chartOptions = {
        series: userSummaryData.map(item => item.LogTypeCount),
        labels: userSummaryData.map(item => item.LogType),
        legend: {
          customLegendItems: userSummaryData.map(item => `${item.LogType} (${item.LogTypeCount})`)
        }
      }
    },
    closeTaskDialog() {
      this.taskDialog = false
    },
    showTaskDialog(commentInfo) {
      this.selectedComment = commentInfo
      this.taskDialog = true;
    },
    nextPage() {
      if (this.items && this.items.length <= 0) return;
      this.postObject.conditions.userId = this.items[0].Users_ID
      this.postObject.pageNumber += 1
      this.getUserCommentsPaging(this.postObject).then((res) => {
        JSON.parse(res.data).forEach(rec => {
          this.items.unshift(rec)
        })
      })
    },
    async showDetails(item) {
      this.selectedUsersId = item.Users_ID
      this.userRequest.conditions.userId = item.Users_ID
      await this.getUserReports(this.userRequest).then((res) => {
        this.customerAdded = JSON.parse(res.customerAdded)
        this.summaryCustomerItems = JSON.parse(res.summaryCustomer)
        this.summaryCustomerItems.forEach(rec => {
          this.wordCloudItems.push([rec.CS_Name, parseInt(rec.EntryCount)])
        });
        this.items = JSON.parse(res.data)
        this.items.forEach((rec) => {
          rec.PersianVisitDateTime = this.ToJalaliDateTime(rec.VisitDateTime)
          rec.PersianVisitDateTimeDay = parseInt(this.ToJalaliDateTimeGetDay(rec.VisitDateTime))
        })
        this.days = this.lodash.orderBy(this.lodash.unionBy(this.items.map(item => item.PersianVisitDateTimeDay)))
        this.itemsOptions = this.items
        const userSummaryData = this.lodash(this.itemsOptions).groupBy('LogType')
            .map(function (items, LogType) {
              return {
                LogType: LogType,
                LogTypeCount: items.length,
              };
            }).value();
        this.CustomerCommentChartOptions.chartOptions = {
          series: userSummaryData.map(item => item.LogTypeCount),
          labels: userSummaryData.map(item => item.LogType),
          legend: {
            customLegendItems: userSummaryData.map(item => `${item.LogType} (${item.LogTypeCount})`)
          }
        }
      })
    },
    showCustomerInfoDialog(customerId) {
      this.getCustomerInfo(customerId).then((res) => {
        this.selectedCustomer = res.data[0]
        this.showCustomerFullInfo = true
      })
    },
    loadData() {
      this.setItems(this.postObject).then((res) => {
        this.summaryCustomers = JSON.parse(res.summaryCustomer)
        this.summaryItems = JSON.parse(res.summary).filter(item => item.Users_ID === parseInt(this.$store.state.userId) || this.$store.state.roles.some(v => ['admin', 'salemanager'].includes(v)))
        this.itemsOptions = this.items
      })
    }
  },
  watch: {
    logType: function (val) {
      if (val === 'همه موارد') {
        this.itemsOptions = this.items
      } else {
        this.itemsOptions = this.items.filter(item => item.LogType.includes(val.trim()))
      }
    }
  },
  created() {
    if (!this.$store.state.roles.some(v => ['admin', 'can_see_secret_comment'].includes(v))) {
      this.reportItemsOptions = this.reportItems.filter(item => item.value = 0)
    } else {
      this.reportItemsOptions = this.reportItems
    }
    this.loadData()
  }
}
</script>

<style scoped>

</style>